<template>
  <div>
    <div class="card mb-5 mb-xl-10">
      <BlockUI :loading="block" />
      <!--begin::Card header-->
      <div class="border-bottom">
        <!--begin::Card title-->

        <div class="row ps-8 pe-8 pt-5 pb-5 align-items-center">
          <!--begin::Label-->
          <div class="col-lg-4">
            <h3 class="d-flex flex-column m-0">
              {{ translate("Users") }}
              <span class="text-muted mt-1 fw-bold fs-7"
                >{{ records }} {{ translate("Records_Found") }}</span
              >
            </h3>
            <!--end::Label-->
          </div>
          <!--begin::Col-->
          <div class="col-lg-8">
            <!--begin::Row-->
            <div class="row">
              <!--begin::Col-->
              <div class="col-lg-3 fv-row"></div>
              <div class="col-lg-6 fv-row d-flex">
                <div class="d-flex align-items-center position-relative my-1 w-100">
                  <span class="svg-icon svg-icon-1 position-absolute ms-6">
                    <i class="bi bi-search fs-3 text-gray-600"></i>
                  </span>
                  <input
                    type="text"
                    class="form-control form-control-white ps-15 form-control-sm border"
                    :placeholder="
                      translate('project_detail_user_input_seacrh_placeholder')
                    "
                    v-model="filterObject.fullName"
                    @keydown.enter="Search"
                    @keyup.delete="inputNull"
                  />
                </div>
              </div>
              <!--end::Col-->

              <!--begin::Col-->
              <div class="col-lg-3 fv-row d-flex">
                <div class="row align-items-center justify-content-end w-100 mx-0 m-2">
                  <button
                    class="btn btn-sm btn-primary border ps-2 pe-2"
                    @click="listActive = !listActive"
                  >
                    <span>{{ translate("project_detail_user_button_add") }}</span>
                  </button>
                </div>
              </div>
              <!--end::Col-->
            </div>
            <!--end::Row-->
          </div>
          <!--end::Col-->
        </div>
      </div>
      <div
        class="d-flex justify-content-between p-8 pt-6 pb-6 border-bottom"
        style="background: #fbfbfb"
      >
        <div
          v-show="userList.length > 0"
          class="form-check form-check-custom form-check-solid"
          style="margin-left: 2.3rem !important"
        >
          <input
            ref="checkAll"
            class="form-check-input"
            type="checkbox"
            @change="selectAll($event)"
            id="check-all"
          />
          <label
            class="form-check-label text-primary fw-bolder fs-7"
            style="margin-left: 1.3rem !important"
            for="check-all"
          >
            {{ translate("Select_All") }}
          </label>
        </div>

        <button
          v-show="userList.filter((i) => i.checked === true).length > 0"
          @click="removeUser()"
          type="button"
          class="btn bg-white bg-hover-secondary btn-sm border position-relative ms-2 text-gray-700"
        >
          {{ translate("project_detail_user_button_remove_users")
          }}<span
            class="position-absolute top-0 start-100 translate-middle badge badge-circle badge-danger"
            >{{ userList.filter((i) => i.checked === true).length }}</span
          >
        </button>
      </div>
      <div class="card-body pt-6 pb-0">
        <!--begin::Item-->
        <div
          v-for="(user, index) in userList"
          :key="index"
          class="d-flex align-items-center mb-1 border rounded p-2"
        >
          <!--begin::Bullet-->
          <span
            class="bullet bullet-vertical h-40px"
            :class="`bg-primary`"
          ></span>
          <!--end::Bullet-->

          <!--begin::Checkbox-->
          <div class="form-check form-check-custom form-check-solid mx-5">
            <input
              :id="`check-${user.Id}`"
              class="form-check-input"
              type="checkbox"
              v-model="user.checked"
            />
          </div>
          <!--end::Checkbox-->

          <!--begin::Description-->
          <div class="flex-grow-1">
            <div class="d-flex flex-column position-relative w-100">
              <label
                class="form-check-label col-form-label fw-bold p-0"
                :for="`check-${user.Id}`"
              >
                <a>{{ user.Name }}</a>
              </label>
            </div>
          </div>
          <!--end::Description-->

          <span
            class="badge fs-7 fw-bolder badge-white border"
            style="cursor: pointer"
            @click="removeUser(user.Id)"
            >{{ translate("Remove") }}</span
          >
        </div>
      </div>

      <div class="row ps-8 pe-8 pt-5 pb-5 align-items-center">
        <div class="col-lg-12">
          <Pagination
            @onPage="onPage"
            :TotalData="records"
          />
        </div>
      </div>
    </div>
    <CUserList
      :listActive="listActive"
      @closeList="closeList"
    />
    <!-- :project="project" -->
  </div>
</template>

<script setup>
import CUserList from "@/components/Admin/Customer-Modal/ProjectDetail/P-UserList.vue";
import { ref, reactive, computed, inject } from "vue";
import ProjectModule from "@/store/modules/Customer/ProjectModule";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

// Multi Language
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const store = useStore();

const block = ref(true);
const checkAll = ref();
const userList = computed(() => store.getters["ProjectModule/_getuserList"]);
const records = computed(() => store.getters["ProjectModule/_getuserRecords"]);
const listActive = ref(false);
const projectId = inject("projectId");

const closeList = () => {
  listActive.value = false;
};

// Filter
// Filter
const filterObject = reactive({
  page: 1,
  pageSize: 20,
  projectId: parseInt(projectId),
  fullName: null,
});
const Search = () => {
  getUser();
};
const inputNull = () => {
  if (filterObject.fullName === "" || filterObject.fullName === null) {
    filterObject.fullName = null;
    getUser();
  }
};

// Filter End

const onPage = (e) => {
  filterObject.page = e.step.value;
  filterObject.pageSize = e.pageSize.value;

  getUser();
};
// Filter End

const getUser = () => {
  filterObject.projectId = parseInt(projectId);
  store
    .dispatch("ProjectModule/GET_PROJECT_USERS", filterObject)
    .finally(() => (block.value = false));
};

const removeModel = reactive({
  projectId: projectId,
  userIds: [],
  deleteAll: false,
});
const removeUser = (Id) => {
  if (Id !== undefined) {
    removeModel.userIds.push(Id);
  } else {
    let value = userList.value.filter((i) => i.checked === true);
    value.forEach((x) => removeModel.userIds.push(x.Id));
  }
  ProjectModule.actions.PROJECT_DELETE_USERS(null, removeModel).then((response) => {
    if (response) {
      getUser();
      removeModel.userIds = [];
      checkAll.value.checked = false;
    }
  });
};

const selectAll = (event) => {
  userList.value.forEach((item) => (item.checked = event.target.checked));
};

getUser();
</script>

<style scoped>
.border-radius-left {
  border-radius: 5px 0 0 5px !important;
}
.border-radius-right {
  border-radius: 0 5px 5px 0 !important;
}
.select-menu-list {
  right: 0;
  top: 38px;
  width: 200px;
  background-color: #fff;
  padding: 4px 2px 2px 2px;
  z-index: 5;
}
.select-menu-list li {
  list-style-type: none;
  margin-bottom: 2px;
  padding: 4px 2px 4px 5px;
  color: #3f4254;
}
.select-menu-list li:hover {
  background-color: #04c8c8;
  font-weight: 500;
  color: #fff;
}
.select-item {
  background-color: #04c8c8a9;
  color: #fff !important;
  font-weight: 500;
}
.made-enter-active,
.made-leave-active {
  transition: opacity 0.2s ease;
}

.made-enter-from,
.made-leave-to {
  opacity: 0;
}
</style>
